import { toUrl } from "@/utils"
import { viapiSegment, viapiJobResult } from './api'
import { computed } from "vue"
import type { Attr, BoundingRect, CartData, Color, CustomableImage, CustomAreas, CustomizedImage, CustomSpu, RawCustomizedImage, SimpleSku, SimpleSpu } from "./types"
export const convertToCustomizedImage = (image: RawCustomizedImage): CustomizedImage => {
  const o = Object.assign({
    customized_image: image.customized_image,
    price: image.price
  }, image.customableImage, image.customized_areas) as unknown as CustomizedImage
  return o
}

// 默认颜色
export const color = (customSpu: CustomSpu) => {
  const customSku = customSpu.customSkus[0] || null
  const color =
    customSku?.sku.attrs.filter((el) => {
      return el.attribute.key === "color"
    }) || null
  const value = color ? color[0].object_value : null
  return value
}

export const templateBasicParameters = (image: string, color: string, width: number, height: number, cornerSize: number = 15) => {
  return Object.assign({}, { image, color, width, height, cornerSize })
}

export const assignCustomizedData = computed(() => (custom_areas: CustomAreas, bgWidth: number, customable_image_scale: number, boundingRect: BoundingRect) => {
  return Object.assign({},
    { ...(custom_areas || {}) },
    { scale: (200 / bgWidth) * (customable_image_scale || custom_areas.scale) },
    boundingRect || {})
})

export const assignOriginalCustomizedData = computed(() => (item: any) => {
  return Object.assign({},
    { ...(item.custom_areas || {}) },
    { scale: (item.customable_image_scale || item.custom_areas.scale) },
    item.boundingRect || {})
})

export const renderImageBaseUrl = (record: any) => {
  const baseHeightRatio = Math.round(record.spu_custom_height * (200 / record.spu_custom_width))
  return toUrl(record.spu_customable_image) + `?x-oss-process=image/resize,h_${baseHeightRatio},m_lfit`
}

export const renderImageCustomUrl = (record: any) => {
  if (!record.customized_areas)
    return toUrl(record.image)

  const scaleRatio = record.customized_areas.customable_image_scale || record.spu_custom_areas.scale
  // const heightRatio = Math.round((record.customized_areas.boundingRect.height || record.spu_custom_areas.height) * (200 / record.spu_custom_width) * scaleRatio)
  const widthRatio = Math.round((record.customized_areas.boundingRect.width || record.spu_custom_areas.width) * (200 / record.spu_custom_width) * scaleRatio)
  const renderCustomUrl = toUrl(record.image) + `?x-oss-process=image/resize,w_${widthRatio}/quality,q_90`

  return renderCustomUrl
}

export const convertImageAndColor = (value: any) => {
  const conver = [] as any
  value.attrs.forEach((r: Attr) => {
    if (r.attribute.key === 'color') {
      r.object_value.forEach((res: any) => {
        conver.push({
          image: '',
          value: res.value || '',
          name: res.name || '',
        })
      })
    }
  })

  if (value.customableImages[0].altImages.length) {
    value.customableImages[0].altImages.forEach((r: any) => {
      conver.forEach((res: any) => {
        if (r.attrs[0].object_value.value === res.value) {
          res.image = r.alt_image
        }
      })
    })
  }

  return conver
}

export const convertColor = (strColor: any): Color | undefined => {
  if (typeof strColor !== 'string') {
    return strColor
  }

  try {
    return JSON.parse(strColor)
  } catch (e) {
    return { name: '', value: strColor }
  }
}

export const convertSpuToSimpleSpu = (customSpu: CartData): SimpleSpu => {
  const colors: Array<Color> = []
  let sizes: Array<string> = []
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const skus: SimpleSku[] = []
  customSpu.skus?.forEach((item) => {
    const sku: SimpleSku = {
      key: 0,
      color: undefined,
      size: '',
      code: '',
      id: 0
    }
    sku.key = item.id
    sku.code = item.code
    sku.id = item.id
    const skuAttrs = !customSpu.is_custom ? item.attrs : item.sku?.attrs
    skuAttrs?.forEach((arr) => {
      if (arr.attribute.key === 'color') {
        const c = convertColor(arr.value || arr.object_value)
        sku.color = c
        item.color = c
        if (c && !colors.find(a => c.value === a.value)) {
          colors.push(c)
        }
      }
      if (arr.attribute.key === 'size') {
        sizes.push(arr.value)
        sku.size = arr.value
        item.size = arr.value
      }
    })
    skus.push(sku)
  })
  sizes = [...new Set(sizes)]
  return {
    colors,
    sizes,
    customSkus: skus,
  }
}
export const convertCustomSpuToSimpleSpu = (customSpu: CustomSpu): SimpleSpu => {
  const colors: Array<Color> = []
  let sizes: Array<string> = []
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const skus: SimpleSku[] = []
  customSpu.customSkus.forEach((item) => {
    const sku: SimpleSku = {
      key: 0,
      color: undefined,
      size: '',
      code: '',
      customCode: 0,
      id: 0
    }
    sku.key = item.id
    sku.customCode = item.id
    sku.code = item.code
    item.sku.attrs.forEach((arr) => {
      if (arr.attribute.key === 'color') {
        const c = convertColor(arr.value || arr.object_value)
        sku.color = c
        item.color = c
        if (c && !colors.find(a => c.value === a.value)) {
          colors.push(c)
        }
      }
      if (arr.attribute.key === 'size') {
        sizes.push(arr.value)
        sku.size = arr.value
        item.size = arr.value
      }
    })
    skus.push(sku)
  })
  sizes = [...new Set(sizes)]
  return {
    colors,
    sizes,
    customSkus: skus,
  }
}
/**
 * 从AltImages里查找匹配当前颜色的备用图片
 *
 * @param color
 * @param customableImage
 * @returns
 */
export const findCustomableImage = (color: Color, customableImage: CustomableImage) => {
  if (color && customableImage.altImages && customableImage.altImages.length >= 0) {
    const altImage = customableImage.altImages.find(i => {
      return i.attrs?.find(attr => {
        return attr.spuAttr.attribute.key === 'color'
          && convertColor(attr.value || attr.object_value)?.value === color.value
      })
    })
    if (altImage && altImage.alt_image) {
      return altImage.alt_image
    }
  }
  return customableImage.image
}
export const sortBy = (attr: any, rev: any) => {
  // 第二个参数没有传递 默认升序排列
  if (rev == undefined) {
    rev = 1
  } else {
    rev = (rev) ? 1 : -1
  }

  return function (a: any, b: any) {
    a = a[attr]
    b = b[attr]
    if (a < b) {
      return rev * -1
    }
    if (a > b) {
      return rev * 1
    }
    return 0
  }
}

export interface SegmentHDCommonImageHandlers {
  /** 抠图成功，返回结果图地址 */
  onSuccess: (resultImageUrl: string) => void
  /** PROCESS_FAILED：处理失败 */
  onProcessFailed: () => void
  /** TIMEOUT_FAILED / LIMIT_RETRY_FAILED / 60s 整体超时 */
  onTimeout: () => void
  /** 提交任务失败（重试 3 次后仍失败）。缺省时回退到 onProcessFailed */
  onSubmitFailed?: () => void
}

/**
 * 提交阿里云 viapi 抠图任务并轮询结果。
 * 凭证由后端 svc-pms 代理持有，前端不接触 AccessKey。
 * 内置：提交重试 3 次、500ms 轮询、60s 整体超时保护（原代码缺失，会无限轮询，本次补齐）。
 */
export const requestSegmentHDCommonImage = (
  imageUrl: string,
  handlers: SegmentHDCommonImageHandlers
): void => {
  const { onSuccess, onProcessFailed, onTimeout, onSubmitFailed } = handlers
  const submitFailed = onSubmitFailed ?? onProcessFailed
  let settled = false
  let polling: ReturnType<typeof setInterval> | undefined
  let overallTimeout: ReturnType<typeof setTimeout> | undefined

  const settle = (action: () => void) => {
    if (settled) return
    settled = true
    if (polling) clearInterval(polling)
    if (overallTimeout) clearTimeout(overallTimeout)
    action()
  }

  // 60s 整体超时保护（原前端代码缺失，会无限轮询）
  overallTimeout = setTimeout(() => settle(() => onTimeout()), 60000)

  const startPolling = (requestId: string) => {
    polling = setInterval(() => {
      viapiJobResult(requestId)
        .then((res) => {
          // QUEUING：任务排队中 PROCESSING：异步处理中 PROCESS_SUCCESS：处理成功
          // PROCESS_FAILED：处理失败 TIMEOUT_FAILED：任务超时未处理完成 LIMIT_RETRY_FAILED：超过最大重试次数
          const status = res?.raw?.Data?.Status
          if (status === 'PROCESS_SUCCESS') {
            // Result 理论上为 JSON 字符串，但防御性解析：畸形时按处理失败回调，避免异常被吞后无限轮询到超时
            try {
              const resultImageUrl = JSON.parse(res.raw.Data.Result).imageUrl
              settle(() => onSuccess(resultImageUrl))
            } catch (e) {
              console.warn('[viapi] parse segment result failed', res?.raw?.Data?.Result, e)
              settle(() => onProcessFailed())
            }
          } else if (status === 'PROCESS_FAILED') {
            settle(() => onProcessFailed())
          } else if (status === 'TIMEOUT_FAILED' || status === 'LIMIT_RETRY_FAILED') {
            settle(() => onTimeout())
          }
          // QUEUING / PROCESSING / 其他 → 继续轮询
        })
        .catch((err) => {
          // 单次轮询失败不中断，下次自动重试；记录日志便于排查
          console.warn('[viapi] jobResult poll failed', err)
        })
    }, 500)
  }

  // 提交抠图任务（最多 3 次，失败后指数退避避免立即重试加重上游负担）
  let attempt = 0
  const submit = () => {
    viapiSegment(imageUrl)
      .then((res) => {
        if (res?.requestId) {
          startPolling(res.requestId)
        } else {
          if (attempt < 2) { attempt++; setTimeout(submit, 300 * attempt); return }
          settle(() => submitFailed())
        }
      })
      .catch((err) => {
        console.warn('[viapi] segment submit failed', err)
        if (attempt < 2) { attempt++; setTimeout(submit, 300 * attempt); return }
        settle(() => submitFailed())
      })
  }
  submit()
}
